$(function() {
	var _learnq = _learnq || [];

	$('.addtoklaviyo').on('click', function(e) {
		e.preventDefault();
		if ($('#kl-mail').val().length) {


			_learnq.push(['identify', {
				'$email': $('#kl-mail').val(),
				'name': $('#appname').val(),
				'formsignup': true
			}]);

			$('.kl-notifier').html('Thank you for subscribing.');
			setTimeout(function() {
				$('.kl-notifier').html('');
			}, 3000);

		}

		if ($('#kl-phone').val().length) {
			_learnq.push(['identify', {
				'$phone_number': $('#kl-phone').val(),
				'formsignup': true
			}]);
			var smsbump_request = {
				form_id: 187371,
				name: $('#appname').val(),
				email: $('#kl-mail').val(),
				phone: $('#kl-phone').val().trim(),
				accepts_marketing: true,
				email_consent: true,
				source: 'Privy'
			};
			if (smsbump_request.phone.length) {
				var smsbXhr = new XMLHttpRequest();
				smsbXhr.open('POST', 'https://api.smsbump.com/v2/formsPublic/subscribe');
				smsbXhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
				smsbXhr.setRequestHeader('X-SMSBump-Platform', 'shopify');
				smsbXhr.onload = function() {
					if (smsbXhr.status === 200) {
						console.log('smsbump subscribe')
					} else if (smsbXhr.status !== 200) {
						console.log('smsbump error')
					}
				};
				var query = encodeURI('form_id=' + smsbump_request.form_id + '&phone=' + smsbump_request.phone + '&accepts_marketing=' + smsbump_request.accepts_marketing + '&email=' + smsbump_request.email + '&email_consent=' + smsbump_request.email_consent + '&source=' + smsbump_request.source);
				smsbXhr.send(query);
			}	

			$('#kl-mail').val('');
			$('#kl-phone').val('');
			$('#appname').val('');
			$('.kl-notifier1').html('Thank you for subscribing.');


			setTimeout(function() {
				$('.kl-notifier').html('');
			}, 3000);
		}

	});

});